import { profession } from "@eca/shared";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { client, unwrap } from "@/lib/api";
import { useMe } from "@/lib/session";

export function useOfficeId(): string {
  const { officeId } = useParams();
  return officeId!;
}

export const officeKey = (officeId: string) => ["office", officeId] as const;

export function useOffice(officeId: string) {
  // No office yet (an administrator before the first office): nothing to ask.
  return useQuery({ queryKey: officeKey(officeId), queryFn: () => unwrap(client.offices[":officeId"].$get({ param: { officeId } })), enabled: !!officeId });
}

/** The office's 士業 (税理士・弁護士 …): its labels, sources and review rules for the screens. */
export function usePack(officeId: string) {
  return profession(useOffice(officeId).data?.profession ?? "tax_accountant");
}

export function useSupervisors(officeId: string) {
  return useQuery({ queryKey: ["supervisors", officeId], queryFn: () => unwrap(client.offices[":officeId"].supervisors.$get({ param: { officeId } })) });
}

export function useRole() {
  return useMe().data?.user.platformRole ?? "office";
}
